import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrderList from './pages/Orders/OrderList';
import OrderDetail from './pages/Orders/OrderDetail';
import OrderForm from './pages/Orders/OrderForm';
import Reconciliation from './pages/Reconciliation';
import Reports from './pages/Reports';
import MasterData from './pages/MasterData';
import UserManagement from './pages/UserManagement';
import AuditTrail from './pages/AuditTrail';
import Complaints from './pages/Complaints';
import Vouchers from './pages/Vouchers';

const PrivateRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<OrderList />} />
            <Route path="orders/new" element={<OrderForm />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="orders/:id/edit" element={<OrderForm />} />
            <Route path="reconciliation" element={<Reconciliation />} />
            <Route path="complaints" element={<Complaints />} />
            <Route path="vouchers" element={<Vouchers />} />
            <Route path="reports" element={<Reports />} />
            <Route path="masters" element={<PrivateRoute roles={['Admin']}><MasterData /></PrivateRoute>} />
            <Route path="users" element={<PrivateRoute roles={['Admin']}><UserManagement /></PrivateRoute>} />
            <Route path="audit" element={<PrivateRoute roles={['Admin']}><AuditTrail /></PrivateRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
